import { InputMask } from 'imask';
import { useState } from 'react';
import { IMaskInput } from 'react-imask';

import { formatBirthDate as formatBirthDateDisplay } from '../../utils';

import { DateFieldProps } from './interfaces';
import { submitDate } from './utils';

const DateField = (props: DateFieldProps) => {
  const {
    value: propValue,
    onChange,
    className,
    dataName,
    formatMask = '00/00/0000',
    required,
    name,
    setIsValid,
  } = props;

  const [value, setValue] = useState<string>(() =>
    propValue ? formatBirthDateDisplay(new Date(propValue)) : '',
  );

  const handleAccept = (val: string, mask: InputMask<any>) => {
    setValue(val);

    if (mask.masked.isComplete) {
      onChange(submitDate(val));
    } else {
      setIsValid?.(false);
    }
  };

  return (
    <IMaskInput
      name={name}
      required={required}
      type="text"
      className={className}
      placeholder="DD/MM/YYYY"
      mask={formatMask}
      value={value}
      autoFocus={true}
      onAccept={handleAccept}
      autoComplete="date-of-birth"
      data-input={dataName}
    />
  );
};

export default DateField;
